import { observer } from 'mobx-react'
import { useContext } from 'react'

import { DocumentsTable } from '@/components/DocumentsTable'
import { Layout } from '@/components/Layout'
import { getDocuments } from '@/services/documents.service'
import { UserStoreContext } from '@/stores/UserStore'
const UserCertificates = observer(() => {
  // Context
  const { user } = useContext(UserStoreContext)

  const documentLoader = (params) =>
    getDocuments({ ...params, owner: user.id, type: 'Certificate' })

  const filters = [{ type: 'input', label: 'Search', id: 'search' }]
  return (
    <Layout breadcrumbs={['Certificates']}>
      <Layout.Heading title="Certificates" />
      <DocumentsTable
        getDocuments={documentLoader}
        filters={filters}
        showAccount
        showType={false}
        extraQueryKeys={{ owner: user.id, type: 'Certificate' }}
      />
    </Layout>
  )
})

export default UserCertificates
